import { RouteRecordRaw } from 'vue-router'
import { privateRoute } from '@/router/navGuards'

export default [
  {
    name: 'Texts',
    path: 'texts',
    component: () => import('@/components/texts/Texts'),
    meta: { private: true },
    beforeEnter: privateRoute,
  },
  {
    name: 'Text',
    path: 'texts/read',
    component: () => import('@/components/texts/Reader'),
    meta: { private: true },
    beforeEnter: privateRoute,
  },
] as RouteRecordRaw[]
